package com.meistercharts.charts.pv.stringsPlanning

import com.meistercharts.algorithms.layers.addClearBackground
import com.meistercharts.algorithms.layers.addShowLoadingOnMissingResources
import com.meistercharts.canvas.BindContentAreaSize2Property
import com.meistercharts.canvas.ConfigurationDsl
import com.meistercharts.canvas.MeisterchartBuilder
import com.meistercharts.canvas.resize.addResizeByHandlesLayer
import com.meistercharts.charts.ChartGestalt
import com.meistercharts.charts.pv.roofPlanning.PvRoofPlanningLayer
import com.meistercharts.charts.pv.roofPlanning.PvRoofPlanningModel
import com.meistercharts.charts.pv.roofPlanning.RoofBackgroundLayer
import com.meistercharts.model.Insets
import com.meistercharts.resize.ResetToDefaultsOnWindowResize
import com.meistercharts.zoom.FittingWithMarginAspectRatio
import it.neckar.geometry.AxisOrientationX
import it.neckar.geometry.AxisOrientationY

/**
 * Gestalt for roof planning
 */
class PvStringsPlanningGestalt(
  val configuration: Configuration,
  additionalConfiguration: Configuration.() -> Unit = {},
) : ChartGestalt {

  constructor(
    stringsPlanningModel: PvStringsPlanningModel,
    roofPlanningModel: PvRoofPlanningModel,
    additionalConfiguration: Configuration.() -> Unit = {},
  ) : this(Configuration(stringsPlanningModel, roofPlanningModel), additionalConfiguration)

  init {
    configuration.additionalConfiguration()
  }

  val roofBackgroundLayer: RoofBackgroundLayer = RoofBackgroundLayer({ configuration.roofPlanningModel.roofSize })
  val pvRoofPlanningLayer: PvRoofPlanningLayer = PvRoofPlanningLayer(configuration.roofPlanningModel)

  val pvStringsPlanningLayer: PvStringsPlanningLayer = PvStringsPlanningLayer(
    stringsPlanningModel = configuration.stringsPlanningModel,
    roofPlanningLayer = pvRoofPlanningLayer,
  )

  var mode: PvRoofPlanningLayer.Mode
    get() = pvRoofPlanningLayer.configuration.mode
    set(value) {
      roofBackgroundLayer.configuration.mode = value
      //PvStringsPlanningLayer reads the mode from pvRoofPlanningLayer
      pvRoofPlanningLayer.configuration.mode = value
    }

  override fun configure(meisterChartBuilder: MeisterchartBuilder) {
    with(meisterChartBuilder) {
      enableZoomAndTranslation = false
      contentAreaSizingStrategy = BindContentAreaSize2Property(configuration.roofPlanningModel.roofSizeProperty)

      zoomAndTranslationDefaults {
        FittingWithMarginAspectRatio {
          Insets.of(20.0)
        }
      }
      configure {
        chartSupport.windowResizeBehavior = ResetToDefaultsOnWindowResize
      }

      configure {
        chartSupport.rootChartState.axisOrientationY = AxisOrientationY.OriginAtBottom //everything is measured from the bottom
        chartSupport.rootChartState.axisOrientationX = AxisOrientationX.OriginAtLeft //everything is measured from the left

        layers.addClearBackground()
        layers.addLayer(roofBackgroundLayer)
        layers.addLayer(pvRoofPlanningLayer)
        layers.addLayer(pvStringsPlanningLayer)
        layers.addResizeByHandlesLayer()
        layers.addShowLoadingOnMissingResources()
      }
    }
  }

  @ConfigurationDsl
  class Configuration(
    val stringsPlanningModel: PvStringsPlanningModel,
    val roofPlanningModel: PvRoofPlanningModel,
  )
}
